import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const FALLBACK_POSTER = "/fallback-poster.svg";

const normalizeImageUrl = (url) => {
  if (!url) return FALLBACK_POSTER;
  return url.replace(/^http:\/\//i, "https://");
};

function Movie({
  id,
  coverImg,
  title,
  summary,
  genres,
  rating,
  year,
  isFavorite,
  onToggleFavorite,
}) {
  return (
    <article className="movie-card">
      <Link to={`/detail/${id}`} className="movie-poster-link">
        <img
          className="movie-poster"
          src={normalizeImageUrl(coverImg)}
          alt={title}
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = FALLBACK_POSTER;
          }}
        />
      </Link>
      <div className="movie-body">
        <div className="movie-head">
          <h2 className="movie-title">
            <Link to={`/detail/${id}`}>{title}</Link>
          </h2>
          <button
            type="button"
            className={`fav-btn ${isFavorite ? "active" : ""}`}
            onClick={() => onToggleFavorite(id)}
            aria-label={isFavorite ? "Remove favorite" : "Add favorite"}
          >
            {isFavorite ? "★" : "☆"}
          </button>
        </div>
        <p className="movie-meta">
          {year || "N/A"} | ⭐ {Number(rating || 0).toFixed(1)}
        </p>
        <p className="movie-summary">{summary}</p>
        <ul className="genre-list">
          {(genres || []).slice(0, 3).map((genre) => (
            <li key={genre}>{genre}</li>
          ))}
        </ul>
      </div>
    </article>
  );
}

Movie.propTypes = {
  id: PropTypes.number.isRequired,
  coverImg: PropTypes.string,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  genres: PropTypes.arrayOf(PropTypes.string),
  rating: PropTypes.number,
  year: PropTypes.number,
  isFavorite: PropTypes.bool,
  onToggleFavorite: PropTypes.func,
};

Movie.defaultProps = {
  coverImg: FALLBACK_POSTER,
  summary: "",
  genres: [],
  rating: 0,
  year: null,
  isFavorite: false,
  onToggleFavorite: () => {},
};

export default Movie;
